<template>
  <component
    :is="to ? 'router-link' : 'div'"
    :to="to"
    :title="to ? 'View ' + title : undefined"
    class="card card-stats mb-4 mb-xl-0"
    :class="{ 'clickable-card text-decoration-none': to }"
  >
    <div class="card-body">
      <div class="row">
        <div class="col-auto">
          <slot name="icon">
            <i :class="[icon, 'fa-2x']"></i>
          </slot>
        </div>
        <div class="col">
          <h5 class="card-title text-uppercase text-muted mb-0">{{ title }}</h5>
          <span class="h2 font-weight-bold mb-0">{{ total }}</span>
        </div>
      </div>
      <p class="mt-3 mb-0 text-muted text-sm">
        <span class="text-success mr-2">
          <i v-if="lastMonth > 0" class="fa fa-arrow-up"></i>
          {{ lastMonth }}
        </span>
        <span class="text-nowrap">In the last month</span>
      </p>
    </div>
  </component>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      required: true,
    },
    total: {
      type: Number,
      default: 0,
    },
    lastMonth: {
      type: Number,
      default: 0,
    },
    to: {
      type: Object,
      default: null,
    },
  },
}
</script>

<style scoped>
.clickable-card {
  cursor: pointer;
  color: inherit;
  transition: border-color 0.2s;
}
.clickable-card:hover {
  border-color: #00c8f8;
}
.clickable-card:hover .card-title {
  color: #00c8f8 !important;
}
</style>
